export default __webpack_public_path__ + "media/images/celeste_campfire-658c30643f46e3587dfc5d99d199acae.png";